import styled from "@emotion/styled";
import { z } from "zod";

import UIcon from "lib/icons/untitled_ui/UIcon";

// Module scope so the schema keeps a stable identity across renders — useURLState
// memoises its parser on reference equality.
export const LeadsViewModeSchema = z.enum(["table", "board"]);
export type LeadsViewMode = z.infer<typeof LeadsViewModeSchema>;

const Track = styled.div(({ theme }) => ({
  display: "inline-flex",
  flexShrink: 0,
  background: theme.colors.sysBackgroundInactive,
  borderRadius: 4,
  padding: 2,
  gap: 2,
}));

const Segment = styled.button<{ active: boolean }>(({ theme, active }) => ({
  height: 28,
  padding: "0 12px",
  border: 0,
  borderRadius: 3,
  cursor: "pointer",
  display: "inline-flex",
  alignItems: "center",
  whiteSpace: "nowrap",
  gap: 6,
  fontSize: 14,
  fontWeight: 500,
  background: active ? theme.colors.sysBackgroundDefault : "transparent",
  color: active ? theme.colors.sysPrimaryDefault : theme.colors.sysTextSecondary,
  boxShadow: active ? "0 1px 2px rgba(38, 50, 71, 0.12)" : "none",
}));

export function ViewToggle({
  value,
  onChange,
}: {
  value: LeadsViewMode;
  onChange: (value: LeadsViewMode) => void;
}) {
  return (
    <Track role="group" aria-label="Leads view">
      <Segment
        type="button"
        active={value === "table"}
        aria-pressed={value === "table"}
        onClick={() => onChange("table")}
      >
        <UIcon icon="list" size={15} />
        Table
      </Segment>
      <Segment
        type="button"
        active={value === "board"}
        aria-pressed={value === "board"}
        onClick={() => onChange("board")}
      >
        <UIcon icon="grid01" size={15} />
        Board
      </Segment>
    </Track>
  );
}
